import { render, staticRenderFns } from "./WorkIconDocument.vue?vue&type=template&id=1e1f65c9"
import script from "./WorkIconDocument.vue?vue&type=script&lang=js"
export * from "./WorkIconDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports